import type { VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithRef, ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { buttonVariants } from './Button.variants';
import { Spinner } from './Spinner';

export interface ButtonProps
  extends ComponentPropsWithRef<'button'>,
    VariantProps<typeof buttonVariants> {
  /** Pokazuje spinner i blokuje przycisk na czas operacji. */
  loading?: boolean;
  /** Ikona po lewej stronie etykiety. Chowana na czas ladowania. */
  leadingIcon?: ReactNode;
  /** Ikona po prawej stronie etykiety. */
  trailingIcon?: ReactNode;
}

/**
 * Podstawowy przycisk aplikacji.
 *
 * Podczas ladowania przycisk jest wylaczony, a jego szerokosc sie nie zmienia —
 * spinner zastepuje ikone wiodaca, a etykieta zostaje na miejscu.
 */
export function Button({
  className,
  variant,
  size,
  fullWidth,
  loading = false,
  leadingIcon,
  trailingIcon,
  disabled,
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled ?? loading}
      aria-busy={loading || undefined}
      className={cn(buttonVariants({ variant, size, fullWidth }), className)}
      {...props}
    >
      {loading ? <Spinner size="sm" label={null} /> : leadingIcon}
      {children}
      {!loading && trailingIcon}
    </button>
  );
}
